import DesLibraryListViewModel from 'viewmodel/DesLibraryListViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesLibraryList extends DesBaseCatalogAcc {
    constructor() {
        super(DesLibraryListViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {};
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale'];
    }
}

if (!window.customElements.get('des-library-list')) {
    window.customElements.define('des-library-list', DesLibraryList);
}
